import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {LangChange} from '../../../../../../lang-change';
import {CenterNationalityService} from '../../../../services/center-nationality.service';
import {Utils} from '../../../../../../common/services/Utils';
import {CenterNationality} from '../center-nationality';
import {Principal} from '../../../../../../common/services/principal';
import {ModuleExtendedEdit} from '../../../../../../common/enums/module-extended-edit.enum';
import {ModuleENUM} from '../../../../../../common/enums/module.enum';
import {CenterStudyLanguageService} from '../../../../services/center-study-language.service';

@Component({
  selector: 'app-center-nationality-dialog',
  templateUrl: './center-nationality-dialog.component.html',
  styleUrls: ['./center-nationality-dialog.component.scss']
})
export class CenterNationalityDialogComponent extends LangChange implements OnInit {

  itemDto: CenterNationality;
  hasWriteAccess = false;

  options = {};

  constructor(public _dialogRef: MatDialogRef<CenterNationalityDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private _utils: Utils,
              private _principal: Principal,
              private _centerNationalityService: CenterNationalityService,
              private _centerStudyLanguageService: CenterStudyLanguageService) {
    super(_utils._translateService);

  }

  ngOnInit() {
    this.options['CENTER_NATIONALITY'] = {
      nameKz: true,
      nameRu: true,
      code: true,
    };

    this.options['CENTER_STUDY_LANGUAGE'] = {
      nameKz: true,
      nameRu: true,
      nameEn: true,
    };

    this.hasWriteAccess = this._principal.isAdmin() ||
      (this._principal.hasWriteAccess(ModuleENUM.DICTIONARY) && this._principal.hasModuleExtendedEdit(ModuleENUM.DICTIONARY, ModuleExtendedEdit.DATA_EDIT));
    if (this.data.id == 0) {
      this.itemDto = new CenterNationality();
    } else {
      this.load();
    }
  }

  load(): void {
    if (this.data.type == 'CENTER_NATIONALITY') {
      this._centerNationalityService.get(this.data.id).subscribe(
        data => {
          this.itemDto = data;
        }
      );
    } else if (this.data.type == 'CENTER_STUDY_LANGUAGE') {
      this.itemDto = this.data.dto;
    }

  }

  onSubmit() {
    if (this.data.type == 'CENTER_NATIONALITY') {
      this._centerNationalityService.save(this.itemDto).subscribe(
        data => {
          if (data.description === 'isUsed') {
            this._utils.notifyError('duplicate_code_entry', null);
          } else {
            this._utils.notifySuccess('saved', null);
            this._dialogRef.close();
          }
        },
        error => {
          console.error(error);
          this._utils.notifyError('error_occurred', null);
        }
      );
    } else if (this.data.type == 'CENTER_STUDY_LANGUAGE') {
      this._centerStudyLanguageService.save(this.itemDto).subscribe(resp => {
        this._utils.notifyMessage(resp, succ => {
          this._dialogRef.close();
        }, null);

      });
    }
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this._dialogRef.close();
  }

  closeDialog(): void {
    this._dialogRef.close();
  }

  onLangChange(langCode): void {
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/dictionary/nationality/edit/center-nationality-dialog.component.ts